// Sektör paketleri DR18/DR21 — Müşteri kaydı KPI kartındaki "Bu sektör için hazır paket var" ipucu
// (saf karar + localStorage kapatma). Koşul: set yok ∧ Set kur izni ∧ müşteri sektörü kanonik koda
// çözülür ∧ o sektörde ≥1 etkin paket ∧ kullanıcı bu müşteride ipucunu kapatmamış.

import { normalizeSectorCode, type KpiPackage } from "@mahir/shared";
import type { StorageLike } from "./kpi-catalog-sync";

export interface PackageHintArgs {
  /** müşterinin KPI set sayısı; null = henüz yüklenmedi (ipucu yok) */
  setCount: number | null;
  /** müşteri kaydındaki serbest sektör metni */
  sector: string | null | undefined;
  packages: readonly KpiPackage[];
  dismissed: boolean;
  /** Set kur yetkisi (kpi.manage) */
  canFork: boolean;
}

/** Gösterilecek paket (ilk eşleşen etkin paket, liste sırası) ya da null. */
export function shouldShowPackageHint(args: PackageHintArgs): KpiPackage | null {
  if (!args.canFork || args.dismissed || args.setCount === null || args.setCount > 0) return null;
  const code = normalizeSectorCode(args.sector);
  if (!code) return null;
  return args.packages.find((p) => p.status === "active" && p.sectorCode === code) ?? null;
}

export function packageHintStorageKey(userId: string, clientId: string): string {
  return `kpi.pkgHint.${userId}.${clientId}`;
}

export function isPackageHintDismissed(
  storage: StorageLike | null | undefined,
  key: string,
): boolean {
  try {
    return storage?.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function dismissPackageHint(storage: StorageLike | null | undefined, key: string): void {
  try {
    storage?.setItem(key, "1");
  } catch {
    // özel pencere / kota — ipucu bu oturumda kapalı kalır
  }
}
